import * as React from 'react'
import { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { renderTemplate } from '../shared/utils/templateRenderer'
import CustomTabs from '../shared/CustomTabs'
import { useEditorContent } from '../editorContent/useEditor'

/**
 * ArticlePreview: Context-aware article preview component
 *
 * Uses editor context instead of props for clean architecture.
 * No props needed - all data comes from EditorProvider context.
 */
const ArticlePreview = () => {
	const { content } = useEditorContent()
	const [previewMode, setPreviewMode] = useState<'desktop' | 'mobile'>('desktop')

	const previewTabs = [
		{ key: 'desktop', label: 'Desktop' },
		{ key: 'mobile', label: 'Mobile' },
	]

	const generatePreviewHtml = () => {
		// Render the template with variables replaced by sample data
		const rendered = renderTemplate(content.html, content.css)

		return `
			<!DOCTYPE html>
			<html>
			<head>
				<style>
					body { margin: 20px; font-family: Arial, sans-serif; }
					${rendered.css}
				</style>
			</head>
			<body>
				${rendered.html}
			</body>
			</html>
		`
	}

	const handlePreviewModeChange = (mode: string) => {
		setPreviewMode(mode as 'desktop' | 'mobile')
	}

	const getPreviewContainerStyle = () => {
		const baseStyle = {
			border: '1px solid #ddd',
			minHeight: '400px',
			backgroundColor: '#fff',
			transition: 'all 0.3s ease',
		}

		if (previewMode === 'mobile') {
			return {
				...baseStyle,
				maxWidth: '375px',
				margin: '0 auto',
			}
		}

		return baseStyle
	}

	const getIframeStyle = () => {
		const baseStyle = {
			border: 'none',
			height: '400px',
		}

		if (previewMode === 'mobile') {
			return {
				...baseStyle,
				width: '375px',
			}
		}

		return {
			...baseStyle,
			width: '100%',
		}
	}

	return (
		<Row style={{ marginTop: '30px' }}>
			<Col md={12}>
				<div className="preview-section">
					<div className="preview-header" style={{ marginBottom: '15px' }}>
						<h2
							style={{
								fontFamily: 'ES Allianz, Arial, sans-serif',
								fontWeight: 500,
								fontSize: '24px',
								lineHeight: '1.2',
								color: '#033542',
								margin: '0 0 10px 0',
							}}
						>
							Preview Article
						</h2>
						<div className="preview-controls">
							<CustomTabs
								tabs={previewTabs}
								activeTab={previewMode}
								onTabSelect={handlePreviewModeChange}
							/>
						</div>
					</div>
					<div className="preview-container" style={getPreviewContainerStyle()}>
						<iframe style={getIframeStyle()} srcDoc={generatePreviewHtml()} title="Article Preview" />
					</div>
				</div>
			</Col>
		</Row>
	)
}

export default ArticlePreview
